import {
    CardImageGrid,
    StyledCardImage,
    StyledFavoriteButton,
} from '../../../MyItemsItemCards/components/CardImage/CardImageStyles';
import ItemCardSaveIcon from '@/components/GridItemCard/Card/components/ItemCardSaveIcon/ItemCardSaveIcon';
import TimedBadgeContainer from '../TimedBadgeContainer/TimedBadgeContainer';

export type CardImageProps = {
    enterLinkHoverState: () => void;
    isCatalogDone: boolean;
    isMobile: boolean;
    itemId: number;
    leaveLinkHoverState: () => void;
};

const CardImage = ({ enterLinkHoverState, isCatalogDone, isMobile, itemId, leaveLinkHoverState }: CardImageProps) => {
    return (
        <StyledCardImage
            data-testid="timedPlusMyItemsCardImage"
            onMouseEnter={enterLinkHoverState}
            onMouseLeave={leaveLinkHoverState}
        >
            <TimedBadgeContainer itemId={itemId} />
            <StyledFavoriteButton>
                <ItemCardSaveIcon itemId={itemId} />
            </StyledFavoriteButton>
            <CardImageGrid
                alignBannerBottomWithGap
                itemId={itemId}
                shouldGiveRangeForMobileSize={isMobile}
                showBidStatus={!isCatalogDone}
                useInFluidGrid
            />
        </StyledCardImage>
    );
};

export default CardImage;
